enum FCResourceType {
  DSP = 'DSP',
}

export {FCResourceType};
